module.exports = __webpack_public_path__ + "img/banner1.6b3ecd57.jpg";